import React from 'react';
import i18n from 'i18next';
//import { ConsoleWriter } from "istanbul-lib-report";
//import React, {Component} from 'react';
import { initReactI18next } from 'react-i18next';

//import {connect} from 'react-redux';
//import SelectLanguage from "~/routes/components/common_header_language";

export function Mki18n(resources, mode) {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: resources,
      //lng: "en",
      fallbackLng: 'en',
      keySeparator: false, // we do not use keys in form messages.welcome
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });

  const defaultLan = mode;
  i18n.changeLanguage(defaultLan);
}

// const resources = {
//     en: {
//         translation: translationEn
//     },
//     ko: {
//         translation: translationKo
//     }
// };

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // resources: resources,
    //lng: "en",
    fallbackLng: 'en',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// var defaultLan = "en";
// var sessionRoot = sessionStorage["persist:root"];
// if (sessionRoot) {
//     var obj = JSON.parse(sessionStorage["persist:root"]);
//     if (obj) {
//         var mode = obj.mode;
//         if (mode) {
//             while (mode.indexOf('"') >= 0) {
//                 mode = mode.replace('"', '');
//             }
//             defaultLan = mode;
//         }
//     }
// }
// console.log("SessionStoargemode=" + defaultLan);
// i18n.changeLanguage(defaultLan);

export default i18n;
